import type { Commit } from 'vuex';

const actions = {
  updateVerticalNavMenuWidth({ commit }: { commit: Commit }, width:any) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },
  updateStarredPage({ commit }: { commit: Commit }, payload:any) {
    commit('UPDATE_STARRED_PAGE', payload)
  },
  arrangeStarredPagesLimited({ commit }: { commit: Commit }, list:any) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }: { commit: Commit }, list:any) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  toggleContentOverlay({ commit }: { commit: Commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }: { commit: Commit }, val:any) {
    commit('UPDATE_THEME', val)
  },
}

export default actions
